// extracted by mini-css-extract-plugin
module.exports = {"item":"JobCardList_item__2lnYT","sending":"JobCardList_sending__1Mufi"};